export default __webpack_public_path__ + "static/media/Create-documentation.484f275b.md";